export default __webpack_public_path__ + "static/media/community.6ac5b2ab.jpg";